var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-9b09342188fefb54b61fd0b9946ff0fc.svg#icon-arrow-d05e5';
                    var viewUrl = 'svg-sprite-9b09342188fefb54b61fd0b9946ff0fc.svg#view-icon-arrow-d05e5';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };